import { readLocalStorage } from '@/toolbox/helpers/local-storage-helper';
import { KEY_USER_DATA } from '@/toolbox/constants/local-storage';
import { http } from '../http/http';
import { API_URL_BASE } from '@/toolbox/defaults/app';

function buildUrl(base: string, params?: Record<string, any>) {
  if (!params || !Object.keys(params).length) return base;
  const qs = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v == null) continue;
    if (Array.isArray(v)) { v.forEach(it => it != null && qs.append(`${k}[]`, String(it))); continue; }
    if (v instanceof Date) { qs.append(k, v.toISOString().slice(0,10)); continue; }
    if (typeof v === 'boolean') { qs.append(k, v ? '1' : '0'); continue; }
    qs.append(k, String(v));
  }
  return `${base}?${qs.toString()}`;
}

export const reportArriendoRepository = {
  getGrouped: async (params?: Record<string, any>) => {
    const dataUser = readLocalStorage(KEY_USER_DATA);
    const rut_empresa = dataUser?.user?.rut_empresa;
    const merged = { ...params, rut_empresa: params?.rut_empresa ?? rut_empresa };
    const url = buildUrl(`${API_URL_BASE}/v1/reports-arriendo/grouped`, merged);
    const resp = await http.get(url);        
    return resp;               
  },
  getDetail: async (params?: Record<string, any>) => {
    const dataUser = readLocalStorage(KEY_USER_DATA);
    const rut_empresa = dataUser?.user?.rut_empresa;
    const merged = { ...params, rut_empresa: params?.rut_empresa ?? rut_empresa };
    const url = buildUrl(`${API_URL_BASE}/v1/reports-arriendo/details`, merged);
    const resp = await http.get(url);        
    return resp;
  }
};
